export function UnauthorizedErrorRedirect(shouldLogout: boolean = false) {
  if (shouldLogout) {
    localStorage.removeItem('tenantId');
    localStorage.removeItem('token');
  }
  window.location.href = `${import.meta.env.VITE_DASHBOARD_URL}${shouldLogout ? 'login?action=logout' : ''}`;
}
